import { UnavailableInServerSideError } from '../../errors/UnavailableInServerSideError';
import { isServerSideRendering } from '../../utils/isServerSideRendering';
import type { Fetch } from './fetch.types';

/**
 * Creates a fetch instance that uses the native window.fetch API.
 */
export const createWebFetch = (): Fetch => {
  if (isServerSideRendering()) {
    return () =>
      Promise.reject(new UnavailableInServerSideError('createWebFetch'));
  }

  // eslint-disable-next-line no-restricted-globals -- this is the abstraction for fetch
  return window.fetch.bind(window);
};
